import React from 'react'
import { useAppContext } from '@/app/AppContext'
import { AuthRoles, hasRole } from '@/auth/AuthRoles'
import AvatarMenu from './AvatarMenu'
import './shell.css'

interface NavItem { label: string; path: string; match: string; roles: string[] }

const NAV: NavItem[] = [
  { label: 'Home', path: '/home', match: '/home', roles: [AuthRoles.ANY] },
  { label: 'Sites', path: '/admin/sites', match: '/admin/sites', roles: [AuthRoles.ANY] },
  { label: 'Users', path: '/admin/users', match: '/admin/users', roles: [AuthRoles.ADMIN] },
  { label: 'Errors', path: '/admin/errors', match: '/admin/errors', roles: [AuthRoles.ADMIN] },
]

const TopBar: React.FC = () => {
  const { user, currentPath, setCurrentPath } = useAppContext()
  if (!user) return null

  const path = (currentPath || '').split('?')[0]
  const visible = NAV.filter((n) => hasRole(user.roles, n.roles))

  return (
    <header className="topbar">
      <div className="topbar__inner">
        <button className="brand" onClick={() => setCurrentPath('/home')} aria-label="WertzAI Sites home">
          <span className="brand__tile">w</span>
          <span className="header-brand">
            <h1><span>WertzAI</span> <span className="brand__suffix">Sites</span></h1>
          </span>
        </button>

        <nav className="topbar__nav">
          {visible.map((n) => {
            const adminOnly = n.roles.includes(AuthRoles.ADMIN)
            const cls = ['nav-link', adminOnly ? 'nav-link--admin' : '', path.startsWith(n.match) ? 'is-active' : '']
            return (
              <button
                key={n.path}
                className={cls.filter(Boolean).join(' ')}
                onClick={() => setCurrentPath(n.path)}
              >
                {n.label}
              </button>
            )
          })}
        </nav>

        <AvatarMenu />
      </div>
    </header>
  )
}

export default TopBar
